'use client'

import { Separator as SeparatorPrimitive } from 'radix-ui'
import * as React from 'react'

import { cn } from '@/src/designSystem/lib/utils'

const Separator = React.forwardRef<
  React.ComponentRef<typeof SeparatorPrimitive.Root>,
  React.ComponentProps<typeof SeparatorPrimitive.Root> & {
    bleedPadding?: number
  }
>(
  (
    {
      className,
      orientation = 'horizontal',
      decorative = true,
      bleedPadding = 0,
      ...props
    },
    ref
  ) => {
    return (
      <SeparatorPrimitive.Root
        data-slot='separator'
        ref={ref}
        decorative={decorative}
        orientation={orientation}
        className={cn(
          'shrink-0 bg-border data-horizontal:h-px data-horizontal:w-full data-vertical:w-px data-vertical:self-stretch',
          className
        )}
        style={
          {
            width:
              bleedPadding > 0
                ? `calc(100% + ${bleedPadding * 2} * var(--spacing))`
                : undefined,
            marginLeft:
              bleedPadding > 0
                ? `calc(-${bleedPadding} * var(--spacing))`
                : undefined,
          } as React.CSSProperties
        }
        {...props}
      />
    )
  }
)
Separator.displayName = 'Separator'

export { Separator }
